import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

/* ===== Gallery Data ===== */
const galleryData = [
//   {
//     id: 1,
//     imgSrc: "/images/fleets/Hyundai-Aura.jpg",
//     title: "Hyundai Aura",
//   },
//   {
//     id: 2,
//     imgSrc: "/images/fleets/Maruti-Suzuki-Ertiga.jpg",
//     title: "Maruti Suzuki Ertiga",
//   },
//   {
//     id: 3,
//     imgSrc: "/images/fleets/Force-Urbania.jpg",
//     title: "Force Urbania",
//   },
//   {
//     id: 4,
//     imgSrc: "/images/fleets/17-Seater-Tempo-Traveller.jpg",
//     title: "17 Seater Tempo Traveller",
//   },
//   {
//     id: 5,
//     imgSrc: "/images/fleets/20-Seater-Tempo-Traveller.jpg",
//     title: "20 Seater Tempo Traveller",
//   },
//   {
//     id: 6,
//     imgSrc: "/images/fleets/32-Seater-Bus.jpg",
//     title: "32 Seater Bus",
//   },
//   {
//     id: 7,
//     imgSrc: "/images/fleets/35-Seater-Bus.jpg",
//     title: "35 Seater Bus",
//   },
//   {
//     id: 8,
//     imgSrc: "/images/fleets/40-Seater-Bus.jpg",
//     title: "40 Seater Bus",
//   },
//   {
//     id: 9,
//     imgSrc: "/images/fleets/45-Seater-AC-Bus.jpg",
//     title: "45 Seater AC Bus",
//   },
// ];


{
    id: 1,
    imgSrc: "/images/fleets/17-Seater-Tempo-Traveller.jpg",
    title: "17 Seater Tempo Traveller",
  },
  {
    id: 2,
    imgSrc: "/images/fleets/20-Seater-Tempo-Traveller.jpg",
    title: "20 Seater Tempo Traveller",
  },

  // =====================
  // URBANIA
  // =====================

  {
    id: 3,
    imgSrc: "/images/fleets/Force-Urbania.jpg",
    title: "Force Urbania",
  },

  // =====================
  // BUSES
  // =====================

  {
    id: 4,
    imgSrc: "/images/fleets/32-Seater-Bus.jpg",
    title: "32 Seater Bus",
  },
  {
    id: 5,
    imgSrc: "/images/fleets/35-Seater-Bus.jpg",
    title: "35 Seater Bus",
  },
  {
    id: 6,
    imgSrc: "/images/fleets/40-Seater-Bus.jpg",
    title: "40 Seater Bus",
  },
  {
    id: 7,
    imgSrc: "/images/fleets/45-Seater-AC-Bus.jpg",
    title: "45 Seater AC Bus",
  },

  // =====================
  // CARS LAST
  // =====================

  {
    id: 8,
    imgSrc: "/images/fleets/Hyundai-Aura.jpg",
    title: "Hyundai Aura",
  },
  {
    id: 9,
    imgSrc: "/images/fleets/Maruti-Suzuki-Ertiga.jpg",
    title: "Maruti Suzuki Ertiga",
  }
];
/* ===== Booking Component ===== */
export default function Booking({
  cards = [
    
    {
      title: "17 Seater Tempo Traveller",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹2,499",
      seater: "17+1",
      ac: "Yes",
      luggage: "Large Luggage Space",
      fuel: "Diesel",
      transmission: "Manual",
      desc:
        "Perfect for family tours, weddings, pilgrimages, and group travel.",
    },
    {
      title: "20 Seater Tempo Traveller",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹2,799",
      seater: "20+1",
      ac: "Yes",
      luggage: "Large Luggage Space",
      fuel: "Diesel",
      transmission: "Manual",
      desc:
        "Spacious vehicle for large group tours, corporate outings, and events.",
    },
    {
      title: "Force Urbania",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹3,499",
      seater: "12+1",
      ac: "Yes",
      luggage: "Premium Storage",
      fuel: "Diesel",
      transmission: "Manual",
      desc:
        "Luxury travel experience with premium interiors and comfortable seating.",
    },
    {
      title: "32 Seater Bus",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹4,999",
      seater: "32+1",
      ac: "Available",
      luggage: "Dedicated Storage",
      fuel: "Diesel",
      transmission: "Manual",
      desc:
        "Best suited for school trips, corporate transportation, and tourism.",
    },
    {
      title: "35 Seater Bus",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹5,499",
      seater: "35+1",
      ac: "Available",
      luggage: "Dedicated Storage",
      fuel: "Diesel",
      transmission: "Manual",
      desc:
        "Comfortable travel solution for events, tours, and group transportation.",
    },
    {
      title: "40 Seater Bus",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹5,999",
      seater: "40+1",
      ac: "Available",
      luggage: "Dedicated Storage",
      fuel: "Diesel",
      transmission: "Manual",
      desc:
        "Ideal for large groups, office outings, and long-distance travel.",
    },
    {
      title: "45 Seater AC Bus",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹6,499",
      seater: "45+1",
      ac: "Yes",
      luggage: "Dedicated Storage",
      fuel: "Diesel",
      transmission: "Manual",
      desc:
        "Premium AC bus offering maximum comfort for large group tours and pilgrimages.",
    },
{
      title: "Hyundai Aura",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹1,099",
      seater: "4+1",
      ac: "Yes",
      luggage: "2 Large Bags",
      fuel: "Petrol / CNG",
      transmission: "Manual",
      desc:
        "Premium sedan ideal for airport transfers, business travel, local city rides, and outstation trips.",
    },
    {
      title: "Maruti Suzuki Ertiga",
      company: "Aaradhya Travels",
      priceLabel: "Starting ₹1,499",
      seater: "7+1",
      ac: "Yes",
      luggage: "4 Large Bags",
      fuel: "Petrol / CNG",
      transmission: "Manual",
      desc:
        "Comfortable family MPV suitable for local and outstation journeys with ample seating and luggage space.",
    },

  ],
}) {
  const getGalleryItem = (title) =>
    galleryData.find(
      (item) => item.title.toLowerCase() === title.toLowerCase()
    );

  const handleWhatsAppBooking = (title) => {
    const phone = "919529697070";
    const message = `Hello Aaradhya Travels, I want to book ${title}. Please share more details.`;

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <>
      {/* Header */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white">
                  Online Booking
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Booking Section */}
      <section
        className="taxi-rates-page section-space"
        style={{
          backgroundColor: "#f9fafc",
          padding: "80px 0",
        }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((c, idx) => {
              const galleryItem = getGalleryItem(c.title);

              return (
                <div className="col-xl-4 col-md-6 d-flex" key={idx}>
                  <div
                    className="w-100 overflow-hidden"
                    style={{
                      borderRadius: "16px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                      transition: "0.3s",
                    }}
                  >
                    {/* Vehicle Image */}
                    <div
                      style={{
                        background: "#DC9F1B",
                        padding: "20px",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={galleryItem?.imgSrc}
                        alt={c.title}
                        style={{
                          width: "100%",
                          maxHeight: "220px",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    {/* Card Content */}
                    <div
                      style={{
                        background: "#FFB100",
                        color: "#222",
                        padding: "25px",
                        minHeight: "360px",
                      }}
                      className="d-flex flex-column justify-content-between"
                    >
                      <div>
                        <h3 className="text-center mb-2">{c.title}</h3>

                        {/* <p className="text-center text-warning fw-bold mb-4">
                          {c.priceLabel}
                        </p> */}

                        <div className="mb-3">
                          <p>
                            <i className="fas fa-users text-danger me-2"></i>
                            <strong> Seating:</strong> {c.seater}
                          </p>

                          <p>
                            <i className="fas fa-snowflake text-info me-2"></i>
                            <strong> AC:</strong> {c.ac}
                          </p>
{/* 
                          <p>
                            <i className="fas fa-suitcase text-warning me-2"></i>
                            <strong> Luggage:</strong> {c.luggage}
                          </p> */}

                          <p>
                            <i className="fas fa-gas-pump text-success me-2"></i>
                            <strong> Fuel:</strong> {c.fuel}
                          </p>

                          <p>
                            <i className="fas fa-cogs text-primary me-2"></i>
                            <strong> Transmission:</strong>{" "}
                            {c.transmission}
                          </p>

                          {/* <p>
                            <i className="fas fa-user-tie text-light me-2"></i>
                            <strong> Driver:</strong> Included
                          </p> */}
                        </div>

                        {/* <p
                          style={{
                            color: "#ddd",
                            fontSize: "14px",
                            lineHeight: "1.7",
                          }}
                        >
                          {c.desc}
                        </p> */}

                        {/* <ul
                          style={{
                            listStyle: "none",
                            padding: 0,
                            marginTop: "15px",
                            color: "#ddd",
                            fontSize: "14px",
                          }}
                        >
                          <li>✓ Clean & Sanitized Vehicle</li>
                          <li>✓ Professional Driver</li>
                          <li>✓ Comfortable Seating</li>
                          <li>✓ 24×7 Customer Support</li>
                        </ul> */}
                      </div>

                      {/* Buttons */}
                      <div className="d-grid gap-2 mt-4">
                        <button
                          onClick={() =>
                            handleWhatsAppBooking(c.title)
                          }
                          className="btn btn-success"
                        >
                          <i className="fab fa-whatsapp me-2"></i>
                          Book Now
                        </button>

                        {/* <a
                          href="tel:+919529697070"
                          className="btn btn-outline-light"
                        >
                          <i className="fas fa-phone me-2"></i>
                          Call Now
                        </a> */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}


